/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Popover } from '@one-thd/sui-atomic-components';
import { links, pbSpendSummary } from '../../../constants';
import { getImageURL } from '../../../utils/GeneralUtil';
export var ToolTipMessage = function () {
    return (React.createElement("div", { className: "toolTipMessage" },
        React.createElement("p", null,
            pbSpendSummary.spendIncludesLoyalty,
            "\u00A0"),
        React.createElement("br", null),
        React.createElement("p", null, pbSpendSummary.savingIncludes),
        React.createElement("br", null),
        React.createElement("p", null,
            pbSpendSummary.fullDetails,
            "\u00A0",
            React.createElement("a", { className: "u__default-link", target: "_blank", href: links.faqTermsAndConditions, rel: "noreferrer" }, links.termsAndConditionsTitle))));
};
export var SpendSummaryTooltip = function () {
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var handleMouseOver = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    return (React.createElement("span", { className: "sui-pl-2" },
        React.createElement("div", { onMouseOver: handleMouseOver, onFocus: handleMouseOver },
            React.createElement("img", { src: getImageURL('ProTiers/icon-info.svg'), alt: "spend-summary-tooltip-icon", width: "16px", height: "16px" })),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, placement: "bottom" },
            React.createElement(ToolTipMessage, null))));
};
